export default __webpack_public_path__ + "static/media/2.bf096816.svg";